// extracted by mini-css-extract-plugin
export default {"flexContainer":"App_flexContainer__tpnQG","headerRow":"App_headerRow__SDod4","contentRow":"App_contentRow__2Y7Us","footerRow":"App_footerRow__KCSTG"};